import * as React from 'react';
import { connect } from 'react-redux';
import { RequestApiResult, requestAPIActions } from 'loopback-react-request';
import { UserDataBaseModel, ProjectModel } from 'franke-trough-dependencies';
import { GlobalPrivateState } from 'src/api';

export interface ProjectsDispatcherProps {
  userData: RequestApiResult<UserDataBaseModel>;
  dispatch: any;
  projects: RequestApiResult<ProjectModel[]>;
}

const dispatchKey = 'projects';

class ProjectsDispatcherContainer extends React.Component<ProjectsDispatcherProps, any> {

  componentDidMount() {
    this.dispatchProjects();
  }

  componentDidUpdate() {
    const { result } = this.props.projects;
    if (!result) {
      // this.dispatchProjects();
    }
  }

  public render() {
    return null;
  }

  componentWillUnmount() {
    this.props.dispatch(requestAPIActions.loadCleared(dispatchKey));
  }

  private dispatchProjects() {
    const {userData} = this.props;
    if (userData && userData.result && userData.result.id) {
      this.props.dispatch(requestAPIActions.load(
        dispatchKey, {
          url: `/UserData/${userData.result.id}/Projects`
        }
      ));
    }
  }
}

export const ProjectsDispatcher = connect((state: GlobalPrivateState) => ({
  userData: state.userData,
  projects: state.projects,
}))(ProjectsDispatcherContainer);
